import React from 'react';
import { ApolloProvider } from '@apollo/client';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import GlobalStyle from './styles/global';
import { LoginContextProvider } from 'context/LoginContext';
import { TypeStoreProvider } from 'context/TypeStoreContext';
import { GeneralConfigProvider } from 'context/GeneralConfigContext';
import { TitleNavBarProvider } from 'context/TitleNavBarContext';
import { NavBarProvider } from 'context/NavBarContext';
import { MyAccountProvider } from 'context/MyAccountContext';
import { LoadGeneralProvider } from 'context/LoadGeneralContext';
import { SystemNotifyProvider } from 'context/SystemNotifyContext';
import { OptionsModalProvider } from 'context/OptionsModalContext';
import { ItensMenuProvider } from 'context/ItensMenuContext';
import { DynamicPageProvider } from 'context/DynamicPage';
import { RolesUserProvider } from 'context/RolesUserContext';
import { ScreensStaticProvider } from 'context/ScreensStaticContext';
import LoadGeneral from 'components/LoadGeneral';
import MyAccount from 'components/MyAccount';
import SystemNotify from 'components/SystemNotify';
import { graphql } from 'services/api';

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	// <React.StrictMode>
	<ApolloProvider client={graphql}>
		<GeneralConfigProvider>
			<TypeStoreProvider>
				<LoginContextProvider>
					<RolesUserProvider>
						<ItensMenuProvider>
							<OptionsModalProvider>
								<SystemNotifyProvider>
									<LoadGeneralProvider>
										<MyAccountProvider>
											<NavBarProvider>
												<TitleNavBarProvider>
													<ScreensStaticProvider>
														<DynamicPageProvider>
															<App />
															<GlobalStyle />
															<LoadGeneral />
															<MyAccount />
															<SystemNotify />
														</DynamicPageProvider>
													</ScreensStaticProvider>
												</TitleNavBarProvider>
											</NavBarProvider>
										</MyAccountProvider>
									</LoadGeneralProvider>
								</SystemNotifyProvider>
							</OptionsModalProvider>
						</ItensMenuProvider>
					</RolesUserProvider>
				</LoginContextProvider>
			</TypeStoreProvider>
		</GeneralConfigProvider>
	</ApolloProvider>
	// </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
